import { useCallback } from "react";
import { getMeme } from "store/features/memeGenerator/utils/getMeme";
import { useMemeEditor } from "../../../MemeEditorContext";

export const useMemeContainer = () => {
    const { itemsContainerRef } = useMemeEditor();
    const getContainer = useCallback(() => {
        const meme = getMeme();
        return {
            left:
                itemsContainerRef?.current?.getBoundingClientRect().left ||
                0 + meme.settings.image.left + meme.settings.itemsContainer.left,
            top:
                itemsContainerRef?.current?.getBoundingClientRect().top ||
                0 + meme.settings.image.top + meme.settings.itemsContainer.top,
        };
    }, [itemsContainerRef]);
    return { getContainer };
};
